module.exports = __webpack_public_path__ + "static/media/99.1f1ba033.png";